export default "__VITE_PUBLIC_ASSET__70fdc739__"